export default "__VITE_ASSET__f83f9f68__"